<template>
    <div>
        <div v-if="gamesStore[type].ready && providerStore.ready" class="relative">
            <div v-if="!loaded" class="loading_bg">
                <Spinner></Spinner>
            </div>
            <div class="flex justify-end py-3">
                <DForm novalidate>
                    <div class="search_box">
                        <div class="relative">
                            <input id="pgt_search_input" v-model="game_input" @input="searchBuffer()" type="text" class="search_input border_search_custom" :placeholder="$t('search_game_dot')" autocapitalize="off">
                             <Icon iconClass="icon-search search_icon"></Icon>
                            <svg v-if="game_input"  @click="game_input = ''; handleSearch()" class="clean_search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </div>
                    </div>
                </DForm>
            </div>
            <div class="tab_btn_container mt-5 flex items-center w-full overflow-auto none-scrollbar pb-[10px]" ref="providerTabList">
                <button @click="selectProviderTab(i, index)" v-for="(i, index) in gamesStore[type].list" :key="index" type="button" class="block mr-3 relative" :class="index == selected_index_tab ? 'active' : ''" :aria-label="index">  
                    <img v-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_vpn == 1" class="vpn_tag select-none"  src="/img/icons/new_vpn.webp" alt="vpn_tag" :style="getVpnStyle" />
                    <div class="tab_btn_bg relative overflow-hidden">
                        <template v-if="getMaintenanceStatus(index)">
                            <img class="maintenance-tag" draggable="false" src="/img/icons/warning.webp" alt="warning" />
                        </template>
                        <template v-else>
                            <div v-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_hot == 1" class="provider_hot_tag">
                                <img class="w-[20px] mx-auto" :src="$resolveUrl(`{d}web_asset/hot.png`)" alt="hot">
                            </div>
                            <img v-else-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_new == 1" class="app_tag select-none" draggable="false" src="/img/icons/new_tag.webp" alt="new_tag" />
                        </template>
                        <img class="tab_btn_img w-[30px] select-none" draggable="false" :src="getProviderLogo(index)" :alt="`provider_${index}`" />
                    </div>
                    <div class="tab_btn_text text-center text-xs mt-2 uppercase w-[50px] truncate">{{ index }}</div>
                </button>
                <button v-for="i in providerListAPP" :key="`${i.providerName}_app`" :aria-label="i.providerName" @click="openAPP(i)" type="button" class="block mr-3">
                    <div class="tab_btn_bg relative overflow-hidden">
                        <img class="app_tag select-none" draggable="false" src="/img/icons/app_tag.webp" alt="app_tag" />
                        <img class="w-[30px] select-none" draggable="false" :src="getProviderLogo(i.providerName)" :alt="`provider_${i.providerName}`" />
                    </div>
                    <div class="tab_btn_text text-center text-xs mt-2 uppercase w-[50px] truncate">{{i.providerName}}</div>
                </button>
            </div>
            <div v-if="Object.keys(gamesStore[type].list).length > 0">
                <div v-if="gameList.length > 0" class="home game_container" :key="gameListKey">
                    <div v-if="mainStore.loadingGame" class="loading_bg">
                        <Spinner></Spinner>
                    </div>
                    <div v-for="(g,i) in gameList" class="game_btn placeholder" ref="gameRefs" :class="dashboardStore.maintenanceData[g.provider_id] ? 'maintenance' : ''">
                        <div class="game_btn_aspect_ratio"></div>
                        <div class="game-container">
                            <img :src="$pub(`/img/logo-dark.png`)" alt="game-container-img" />
                        </div>
                        <img class="game_img" loading="lazy" :src="checkImg(g.img)" :alt="`${g.img}`">
                        <!-- <div class="provider_corner_badge">
                            <img class="provider_corner_badge_img" :src="getProviderLogoWhite(g.provider_name)" :alt="`provider_${g.provider_name}`" loading="lazy">
                        </div> -->
                        <div class="game_btn_content" :class="checkFavourite(g)">
                            <div class="game_btn_section">
                                <button @click="favouriteGame(g)" type="button" class="bg-favourite-btn text-base text-[#fff] bg-[var(--primary)] py-[5px] w-full rounded-[50px] bg-oz-primary" :aria-label="$t('favourite')">{{mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id) ? $t("unfavourite") : $t("favourite")}}</button>
                                <button @click="playGame(g)" type="button" class="mt-3 text-base bg-playnow-btn py-[5px] w-full rounded-[50px] bg-oz-game-play-btn" :aria-label="$t('play_now')">{{$t("play_now")}}</button>
                            </div>
                            <div class="game_btn_content_text">{{(g.game_lang && g.game_lang[mainStore.lang]) ? g.game_lang[mainStore.lang] : g.game_name}}</div>
                            <div class="game_btn_content_favourite" @click.stop="favouriteGame(g)">
                                <Icon v-if="mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id)" iconClass="icon-favourite"></Icon>
                                <Icon v-else iconClass="icon-favourite inactive"></Icon>
                            </div>
                            <!-- <div v-if="['jw8','nex191'].includes(config.public.MERCHANT) &&  !['production'].includes(config.public.ENV)">
                                <img v-if="providerStore.meta[type][g.provider_name] && providerStore.meta[type][g.provider_name]?.show_vpn == 1" draggable="false" src="/img/icons/VPN.webp" class="game_vpn_tag select-none" alt="vpn_tag" />
                            </div> -->
                        </div>
                        <div v-if="dashboardStore.maintenanceData[g.provider_id]" class="maintenance_box">
                            <div class="maintenance_text">
                                <div class="maintenance_text_1">
                                    <span v-if="dashboardStore.maintenanceData[g.provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date, end_date: dashboardStore.maintenanceData[g.provider_id].end_date})}}</span>
                                    <span v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date})}}</span>
                                </div>
                                <div class="maintenance_text_2">[{{g.provider_name}}]</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5">
                    <PaginationGame :totalPage="totalPage" :value="currentPage" @change="paginate"></PaginationGame>
                </div>
            </div>
        </div>

        <div v-else class="relative">
            <div class="pt-5 flex items-center w-full overflow-auto light-scrollbar-h pb-[10px]">
                <div class="skeleton w-full h-[70px]"></div>
            </div>
            <div class="mt-5 home game_container">
                <div v-for="i in 48" :key="i" class="game_btn">
                    <div class="game_btn_aspect_ratio skeleton"></div>
                </div>
            </div>
        </div>

        <AppModal :show="appModal" :appModalData="appModalData" @close="appModal = false"></AppModal>
    </div>
</template>

<script setup>
const props = defineProps({
    type: String
});
const gameRefs = ref([])
const route = useRoute();
const config = useRuntimeConfig();
const dashboardStore = useDashboardStore();
const gamesStore = useGamesStore();
const providerStore = useProviderStore();
const mainStore = useMainStore();
const userStore = useUserStore();
const { $api, $toast, $pub, $resolveUrl } = useNuxtApp();
const { screenHeight, screenWidth } = useScreenHeight();

const readyWatcher = watchEffect(() => {
    if (providerStore.ready && (!userStore.loggedIn || (userStore.loggedIn && dashboardStore.ready))) {
        gamesStore.getGames('slot')
        readyWatcher()
    }
}, {
    flush: 'post'
})

watch(() => userStore.loggedIn, async() => {
    await providerStore.getProviders()
    gamesStore.getGames('slot')
})

const loaded = ref(true);

const providerTabList = ref();
const selected_index_tab = ref("ALL");
onMounted(() => {
    const homeProvider = window.localStorage.getItem('homeProvider');
    window.localStorage.removeItem("homeProvider")
    if (homeProvider) {
        selected_index_tab.value = homeProvider;
    }
})
const selectProviderTab = (e, name) => {
    currentPage.value = 1;
    selected_index_tab.value = name;
}

const currentPage = ref(1);
const paginate = (e) => {
    currentPage.value = e;
}

const gameListKey = ref(1)
const totalPage = ref(1)
function buildPagination(array, page_size, page_number) {
    let curr_page_number = page_number;
    
    if(localStorage.getItem('lastgame')) {
        let game_hash = localStorage.getItem('lastgame')
        let game_index = array.map(e => e.game_id).indexOf(game_hash)
        if (game_index >= 0) {
            curr_page_number = Math.ceil((game_index + 1) / page_size)
            currentPage.value = curr_page_number;
        }
    }

    totalPage.value = Math.ceil(array.length / page_size);
    gameListKey.value++
    return array.slice((curr_page_number - 1) * page_size, curr_page_number * page_size);
}

watch(gameListKey, (ko, kn) => {
    if (ko != kn) {
        gameRefs.value = [];
    }
})

watchEffect(() => {
	if (gameRefs.value.length > 0) {
        nextTick(() => {
            if(localStorage.getItem('lastgame')) {
                let game_hash = localStorage.getItem('lastgame')
                window.localStorage.removeItem("lastgame")
                let game_ref_index = gameList.value.findIndex(e => e.game_id == game_hash)
                if (game_ref_index >= 0 && gameRefs.value[game_ref_index]) {
                    setTimeout(() => {
                        const element = gameRefs.value[game_ref_index]
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition - 50 - (screenWidth.value >= 1024 ? 90 : 50);
                        window.scrollBy({
                            top: offsetPosition,
                            behavior: "smooth"
                        });
                    }, 1000)
                }
            }
        })
    }
}, {
	flush: 'post'
})

const checkImg = (e) => {
    if (e) {
        if (e.includes('https')) {
            return e;
        } else {
            return $resolveUrl(`{m}frontend/web/${e}`);
        }
    } else {
        return $pub(`/img/logo.png`);
    }
}

const getProviderLogo = (p) => {
	if (p) {
		return $resolveUrl(`{d}game/provider${config.public.GAME_PROVIDER_LOGO}/${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const getProviderLogoWhite = (p) => {
    if (p) {
        return $resolveUrl(`{d}game/provider_name/${(p.toUpperCase())}_white.webp`);
    } else {
        return $pub('/img/logo.png');
    }
}

const playGame = (e, i) => {
    var game = {
        provider_name: e.provider_name,
        currency: dashboardStore?.data?.currency,
        provider_id: e.provider_id,
        game_id: e.game_id,
        maintenance: dashboardStore?.maintenanceData[e.provider_id]
    }
    // remain previous page
    // gamesStore.selectedGame = {        
    //     tab: selected_index_tab.value,
    //     page: currentPage.value,
    //     item: i
    // }
    
    gamesStore.playGame(game);
}

const checkFavourite = (e) => {
    var checkGameFavourite = mainStore.userFavourite.list.find(obj => obj == e.game_id);
    if (checkGameFavourite) {
        return "favourite"
    } else {
        return ""
    }
}

const favouriteGame = async(e) => {
	if (userStore.loggedIn) {
        var checkGameFavourite = mainStore.userFavourite.list.find(obj => obj.game_id == e.game_id);
        if (checkGameFavourite) {
            mainStore.userFavourite.list = mainStore.userFavourite.list.filter(obj => obj.game_id !== e.game_id);
            gamesStore.toggleFavourite({game_id: e.game_id})

        } else {
            mainStore.userFavourite.list.push({game_id: e.game_id});
            gamesStore.toggleFavourite({game_id: e.game_id})
        }
	} else {
		mainStore.loginModal = true;
	}
}

const pos = ref({ top: 0, left: 0, x: 0, y: 0 });
const mouseDownHandler = (e) => {
    providerTabList.value.style.userSelect = 'none';
    pos.value = {
        // The current scroll
        left: providerTabList.value.scrollLeft,
        top: providerTabList.value.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
    };
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
}
const mouseMoveHandler = (e) => {
    // How far the mouse has been moved
    const dx = e.clientX - pos.value.x;
    const dy = e.clientY - pos.value.y;

    // Scroll the element
    providerTabList.value.scrollTop = pos.value.top - dy;
    providerTabList.value.scrollLeft = pos.value.left - dx;
};
const mouseUpHandler = (e) => {
    providerTabList.value.style.removeProperty('user-select');
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
};
watch(providerTabList, (el) => {
    if (el) {
        providerTabList.value.addEventListener('mousedown', mouseDownHandler);
    }
})

let bufferTimer = null
const searchBuffer = () => {
    if (bufferTimer) {
        clearTimeout(bufferTimer)
    }
    bufferTimer = setTimeout(() => {
        handleSearch()
        clearTimeout(bufferTimer)
        bufferTimer = null
    }, 300)
}

onBeforeUnmount(() => {
    clearTimeout(bufferTimer)
    bufferTimer = null
})

const game_input = ref("");
const searchTerm = ref('')
const handleSearch = async () => {
    searchTerm.value = game_input.value
}

const gameList = computed(() => {
    if (!providerStore.ready || !gamesStore[props.type].ready) {
        return []
    }
    if (!gamesStore[props.type].list[selected_index_tab.value]) {
        return []
    }
    
    let allGames = gamesStore[props.type].list[selected_index_tab.value];

    // filter by search term
    if (searchTerm.value) {
        allGames = allGames.filter(game => {
            let gameNameUpperCase = (game.game_lang && game.game_lang[mainStore.lang]) ? game.game_lang[mainStore.lang].toUpperCase() : game.game_name.toUpperCase()
            let searchTermUpperCase = searchTerm.value.toUpperCase()
            return gameNameUpperCase.indexOf(searchTermUpperCase) > -1
        })
    }

    // select the game for current page
    return buildPagination(allGames, 48, currentPage.value)
})

// Add watcher for route.params.provider
watch(() => route.params.provider, (newProvider) => {
    if (newProvider) {
        selected_index_tab.value = newProvider.toUpperCase();
    }
}, { immediate: true })

// APP LIST
const providerListAPP = computed(()=> {
    if (providerStore.ready && providerStore.data && providerStore.data[props.type]) {
        var totalGame = [];
        var arrayAPP = providerStore.data[props.type].filter(obj => obj.mobile_status == '1');
        for (let i = 0; i < arrayAPP.length; i++) {
            totalGame.push(arrayAPP[i]);
        }
        return totalGame; 
    }
    return []
})

const appModal = ref(false);
const appModalData = ref({
    provider: "",
    provider_name: "-",
    username: "-",
    password: "-",
    url: "-",
});

const openAPP = async (e) => {
    if (!userStore.loggedIn) {
        mainStore.loginModal = true;
        return
    }
    if (mainStore.loadingGame == true) {
        return;
    }
    mainStore.loadingGame = true;
    const res = await $api('mobile/mobile-login', {
        provider_id: e.id,
        currency: dashboardStore.data.currency,
    });
    if (!res.status) {
        mainStore.loadingGame = false;
        $toast(false, res.msg)
        return
    }
    appModalData.value = {
        provider: e.providerName.toUpperCase(),
        provider_name: e.display_name,
        username: res.data.username,
        password: res.data.password,
        url: res.data.url,
        play_link: res.data.play_link,
        provider_data: e,
    }

    appModal.value = true;
    mainStore.loadingGame = false;
}

const getMaintenanceStatus = (p) => {
    if (providerStore.data[props.type]) {
        var getProviderData = providerStore.data[props.type].find(obj => obj.providerName == p);
        if (getProviderData && getProviderData.id && dashboardStore.maintenanceData && dashboardStore.maintenanceData[getProviderData.id]) {
            return true;
        }
        return false;
    }
    return false;
}

const getVpnStyle = computed(() => {    
    return {
         background: mainStore.vpn_tag_color,
         padding:'3px'
    }
})
</script>

<style scoped>
.index_tab {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 16px;
    color: #8F99A3;
    margin-right: 20px;
    position: relative;
}
.index_tab:before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background-color: transparent;
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s;
}

.index_tab.active:before {
    background-color: #997DFF;
}

.game_container {
    margin-top: 20px;
}

.provider_hot_tag {
    position: absolute;
    top: 0px;
    left: 0px;
}

.provider_hot_tag_2 {
    position: absolute;
    top: -10px;
    left: -5px;
}

.clean_search {
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}

.provider_hot_tag {
    position: absolute;
    top: 0px;
    left: 0px;
}

.provider_hot_tag_2 {
    position: absolute;
    top: -10px;
    left: -5px;
}

.border_search_custom{
    border-radius: 50px !important;
}

.maintenance-tag {
    width: 20px;
    position: absolute;
    top: 5px;
    left: 5px;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.vpn_tag {
    width: 25px;
	position: absolute;
	top: 0px;
	right: 0px;
    z-index:10;
}

.game-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.game-container img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
    height: auto;
    filter: grayscale(1);
    pointer-events: none;
}

.provider_corner_badge {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 60px;
    height: 28px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
    border-bottom-right-radius: 8px;
}

.provider_corner_badge_img {
    width: auto;
    max-width: 100%;
    height: 30px;
    display: block;
    object-fit: contain;
}

</style>